import { PocketRow, ToggleSwitch } from "@/components/ui";
import {
  useVoiceWakePreference,
  useVoiceWakeStatus,
} from "@/desktop/voice-wake-store";
import { useT } from "@/i18n";
import { commonMessages } from "@/i18n/messages/common";
import { settingsVoiceMessages } from "@/i18n/messages/settings-voice";
import { isTauri } from "@/lib/is-tauri";

/**
 * Preferences › Voice: the wake word (desktop). While it is off the second
 * line invites it; while it is on, the line is the listener's own status.
 */
export function VoiceWakeRow() {
  const t = useT(settingsVoiceMessages);
  const tCommon = useT(commonMessages);
  const enabled = useVoiceWakePreference((state) => state.enabled);
  const setEnabled = useVoiceWakePreference((state) => state.setEnabled);
  const phase = useVoiceWakeStatus((state) => state.phase);
  const error = useVoiceWakeStatus((state) => state.error);
  if (!isTauri()) return null;
  const line = !enabled
    ? t("wakeInvite")
    : phase === "sleeping"
      ? t("wakeSleeping")
      : phase === "waking"
        ? t("wakeWaking")
        : phase === "listening"
          ? t("wakeListening")
          : phase === "error"
            ? (error ?? t("wakeUnavailable"))
            : tCommon("off");
  return (
    <PocketRow
      testId="settings-row-voice-wake"
      title={t("wakeWord")}
      secondLine={<span role="status">{line}</span>}
      trailing={
        <ToggleSwitch
          checked={enabled}
          onCheckedChange={setEnabled}
          aria-label={t("wakeWord")}
          data-testid="voice-wake-enabled-toggle"
        />
      }
    />
  );
}
